# Features for ad products

Ad products can enable additional job ad [`features`].
When an ad product is selected by the hirer,
your software should conditionally display form inputs that correspond to these features.

[`features`]: /schema/named-type/AdvertisementProduct#/field/features

## Examples

An ad product without any [`features`]:

```json label="AdvertisementProductFeatures"
{
  "branding": null,
  "searchBulletPoints": null
}
```

An ad product with [`features`]:

```json label="AdvertisementProductFeatures"
{
  "branding": {
    "coverImageIndicator": false,
    "logoIndicator": true
  },
  "searchBulletPoints": {
    "limit": 2
  }
}
```

## Branding

If the [`branding`] feature is enabled,
you should display a form input for the hirer to select a brand for their job ad.

import { SeekBrandSelect } from '../../branding';

<SeekBrandSelect variant="multiple-brands" />

While some ad products will display the brand in its entirety on the job ad,
other ad products may be limited to select components of the brand.
For example, the second product above supports a logo but not a cover image.

Your software should still use the same form input for brand selection,
but to provide your hirers with clarity on how the job ad will appear,
you may describe which brand components will apply to the job ad or include a [preview].

See our [branding documentation] for more information.

[`branding`]: /schema/named-type/AdvertisementProductFeatures#/field/branding
[branding documentation]: /use-cases/job-posting/branding
[preview]: /use-cases/job-posting/managing-job-ads/previewing-a-job-ad

## Search bullet points

If the [`searchBulletPoints`] feature is enabled,
you should display form inputs for the hirer to enter key selling points for their job ad.

import { SearchBulletPoints } from '../../assets/SearchBulletPoints';

<SearchBulletPoints limit={2} />

The [`limit`] describes the number of bullet points to request from the hirer.
These help the job ad to stand out in search results.

[`searchbulletpoints`]: /schema/named-type/AdvertisementProductFeatures#/field/searchBulletPoints
[`limit`]: /schema/named-type/AdvertisementProductFeatures_SearchBulletPoints#/field/limit
